import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

export class HomeContainer extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        currentStep: 0
    };

    static propTypes = {
        auth: PropTypes.object.isRequired
    };

    render() {
        return (
            <div className="container-fluid px-0">
                <div className="flex h-[calc(100%-60px)]">
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(HomeContainer)
